(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      // Tide Digital, Aug 2026: keep --announcement-bar-height in sync so the sticky header
      // (see CSS above) always sits directly below the sticky announcement bar, never overlapping it.
      this.announcementBar = document.querySelector('.announcement-bar-section');
      this.setAnnouncementBarHeight();
      if (this.announcementBar && 'ResizeObserver' in window) {
        this.announcementBarObserver = new ResizeObserver(this.setAnnouncementBarHeight.bind(this));
        this.announcementBarObserver.observe(this.announcementBar);
      } else {
        window.addEventListener('resize', this.setAnnouncementBarHeight.bind(this));
      }

      // Tide Digital, Aug 2026: same idea for --trust-bar-height, the second pinned strip
      // (the static Trustpilot bar) below the announcement bar, so the header sits below both.
      this.trustBar = document.querySelector('.trust-bar-static-section');
      this.setTrustBarHeight();
      if (this.trustBar && 'ResizeObserver' in window) {
        this.trustBarObserver = new ResizeObserver(this.setTrustBarHeight.bind(this));
        this.trustBarObserver.observe(this.trustBar);
      } else {
        window.addEventListener('resize', this.setTrustBarHeight.bind(this));
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    setAnnouncementBarHeight() {
      // Tide Digital, Aug 2026: use the fractional rendered height (getBoundingClientRect),
      // not offsetHeight (which rounds to a whole pixel). The rounding left a hairline gap
      // between the announcement bar and the trust bar below it on some screens.
      const height = this.announcementBar ? this.announcementBar.getBoundingClientRect().height : 0;
      document.documentElement.style.setProperty('--announcement-bar-height', `${height}px`);
    }

    setTrustBarHeight() {
      // Tide Digital, Aug 2026: same fix as setAnnouncementBarHeight, fractional height instead
      // of offsetHeight, so the header doesn't leave a hairline gap below the trust bar either.
      const height = this.trustBar ? this.trustBar.getBoundingClientRect().height : 0;
      document.documentElement.style.setProperty('--trust-bar-height', `${height}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      if (this.announcementBarObserver) {
        this.announcementBarObserver.disconnect();
      }
      if (this.trustBarObserver) {
        this.trustBarObserver.disconnect();
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
